import IcArrowFillRoundDownGrey from 'assets/Icons/Arrow/IcArrowFillRoundDownGrey';
import IcArrowFillRoundUpBlue from 'assets/Icons/Arrow/IcArrowFillRoundUpBlue';
import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { BackgroundColor, BorderColor, PrimaryColor } from 'styles/Global/colorSemantic';
import { Body4Medium, Body5SemiBold } from 'styles/Global/typography';

interface AccordionListProps {
    date?: string;
    number?: number;
    selected?: boolean;
    onClick?: () => void;
    children?: ReactNode;
}

export const AccordionList = ({ date, number, selected, onClick, children }: AccordionListProps) => {
    return (
        <AccordionListLayout onClick={onClick}>
            <AccordionListWrapper>
                <DateWrapper>{date}</DateWrapper>
                <NumberWrapper>{number}</NumberWrapper>
            </AccordionListWrapper>
            <ButtonWrapper>{selected ? <IcArrowFillRoundUpBlue /> : <IcArrowFillRoundDownGrey />}</ButtonWrapper>
        </AccordionListLayout>
    );
};

const AccordionListLayout = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 22px;
`;

const AccordionListWrapper = styled.div`
    display: flex;
    align-items: center;
    height: 100%;
    gap: 4px;
`;

const DateWrapper = styled(Body4Medium)``;

const NumberWrapper = styled(Body5SemiBold)`
    color: ${PrimaryColor.color_primary_neutral};
`;

const ButtonWrapper = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
`;
